import { FC, useCallback, useEffect, useState } from 'react'
import {
  Container,
  CloseContainer,
  InvoiceCloudFrame,
  LoaderContainer
} from './styles'
import { IoClose } from 'react-icons/io5'
import loaderImg from 'src/assets/loader.svg'
import { api } from 'src/services/apiClient'
import { useAuth } from 'src/context/auth'

interface Props {
  close?: () => void;
}

const InvoiceCloudModalContent: FC<Props> = ({ close }) => {
  const { user } = useAuth()
  const [invoiceCloudUrl, setInvoiceCloudUrl] = useState('')

  const getInvoiceCloudUrl = useCallback(async () => {
    if(!invoiceCloudUrl) {
      try {
        const { data } = await api.get('Payments/RemoteAuthenticationUrlForFirm', {
          params: {
            firmId: user.firmId
          }
        })

        setInvoiceCloudUrl(data)
      } catch(err) {}
    }
  }, [invoiceCloudUrl, user.firmId])
  
  useEffect(() => {
    getInvoiceCloudUrl()
  }, [getInvoiceCloudUrl])

  return (
    <Container>
      <CloseContainer>
        <button onClick={close}><IoClose /></button>
      </CloseContainer>
      {invoiceCloudUrl ? (
        <InvoiceCloudFrame src={invoiceCloudUrl} sandbox="allow-same-origin allow-scripts"/>
      ) : (
        <LoaderContainer>
          <img src={loaderImg} alt="Loading"/>
        </LoaderContainer>
      )}
    </Container>
  )
}

export default InvoiceCloudModalContent